<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringPoint.meteringPointId' | translate }}</label>
    <input type="text" appInput formControlName="meteringPointIdentification" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input appInputDate formControlName="validFrom">
  </app-input-group>

  <!-- PHYSICAL Meter Form -->
  @if (!isVirtual) {
    <app-input-group>
      <label appLabel>{{ 'meteringpoint.meternumber' | translate }}</label>
      <select appSelect formControlName="meterNumber">
        <option value="null" selected disabled>{{ 'meteringpoint.meter.selectmeter' | translate }}</option>
        @for (item of meterList; track item.id) {
          <option [value]="item.id">
            {{ item.serialNumber ? `Serienummer: ${item.serialNumber}` : '' }}
            {{ item.alternateMeterNumber ? `- Placering: ${item.alternateMeterNumber}` : '' }}
            {{ item.meterNumber ? `- Målernummer: ${item.meterNumber}` : 'Ingen målernummer' }}
          </option>
        }
      </select>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meteringpoint.serialnumber' | translate }}</label>
      <input type="text" appInput formControlName="meterSerialNumber" readonly>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'common.quadrant' | translate }}</label>
      <select appSelect formControlName="quadrant">
        <option disabled>{{ 'common.quadrant' | translate }}</option>
        @for (q of quadrant; track q.key) {
          <option [value]="q.key">
            {{ q.value | translate }}@if (getRegisterForSelectedMeter(q.key); as register) { ({{ register }}) }
          </option>
        }
      </select>
    </app-input-group>
  }

  <!-- VIRTUAL Calculation Form -->
  @if (isVirtual) {
    <app-calculation-form
      [form]="calculationForm"
      [rowHandler]="rowHandler"
      [algorithmDynamic]="algorithmDynamic">
    </app-calculation-form>
  }

</form>
